var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex flex-column gr-10 text--text" }, [
    _c("div", { class: _setup.isMobile ? "text-h6 text-center" : "text-h5" }, [
      _vm._v(
        "\n    " +
          _vm._s(_setup.t("Зачем регистрироваться", _setup.options)) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "benefits-of-registration-list ga-10" }, [
      _c("div", { staticClass: "d-flex flex-column gr-4 flex-grow-1" }, [
        _c("div", { staticClass: "ui-icon-reviews-40 ui-icon_type_40 brand" }),
        _vm._v(" "),
        _c("div", { staticClass: "text-subtitle-1" }, [
          _vm._v(
            "\n        " +
              _vm._s(_setup.t("Отзывы пациентов", _setup.options)) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
          _vm._v(
            "\n        — " +
              _vm._s(_setup.t("Уведомления о новых отзывах", _setup.options)) +
              "\n        "
          ),
          _c("br"),
          _vm._v(
            "— " +
              _vm._s(_setup.t("Приватный чат с автором", _setup.options)) +
              "\n        "
          ),
          _c("br"),
          _vm._v(
            "— " +
              _vm._s(_setup.t("Публикация ответов", _setup.options)) +
              "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column gr-4 flex-grow-1" }, [
        _c("div", { staticClass: "ui-icon-doc-40 ui-icon_type_40 warning" }),
        _vm._v(" "),
        _c("div", { staticClass: "text-subtitle-1" }, [
          _vm._v(
            "\n        " +
              _vm._s(_setup.t("Профиль врача", _setup.options)) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
          _vm._v(
            "\n        — " +
              _vm._s(_setup.t("Актуализация информации", _setup.options)) +
              "\n        "
          ),
          _c("br"),
          _vm._v(
            "— " +
              _vm._s(
                _setup.t("Публикация дополнительных сведений", _setup.options)
              ) +
              "\n        "
          ),
          _c("br"),
          _vm._v(
            "— " + _vm._s(_setup.t("Фотогалерея", _setup.options)) + "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column gr-4 flex-grow-1" }, [
        _c("div", {
          staticClass: "ui-icon-megaphone-40 ui-icon_type_40 secondary",
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-subtitle-1" }, [
          _vm._v(
            "\n        " +
              _vm._s(_setup.t("Привлечение пациентов", _setup.options)) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
          _vm._v(
            "\n        — " +
              _vm._s(_setup.t("Формирование бренда врача", _setup.options)) +
              "\n        "
          ),
          _c("br"),
          _vm._v(
            "— " +
              _vm._s(
                _setup.t(
                  "Публикация ответов на вопросы пациентов",
                  _setup.options
                )
              ) +
              "\n        "
          ),
          _c("br"),
          _vm._v(
            "— " +
              _vm._s(_setup.t("Написание статей о болезнях", _setup.options)) +
              "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _setup.context.request.country.is_russia
        ? _c("div", { staticClass: "d-flex flex-column gr-4 flex-grow-1" }, [
            _c("div", {
              staticClass: "ui-icon-computer-40 ui-icon_type_40 success",
            }),
            _vm._v(" "),
            _c("div", { staticClass: "text-subtitle-1" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _setup.t("«Профи» в подарок на год!", _setup.options)
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
              _vm._v(
                "\n        — " +
                  _vm._s(
                    _setup.t(
                      "Отсутствие рекламы на странице доктора",
                      _setup.options
                    )
                  ) +
                  "\n        "
              ),
              _c("br"),
              _vm._v(
                "— " +
                  _vm._s(
                    _setup.t(
                      "Отсутствие раздела «популярные врачи в городе»",
                      _setup.options
                    )
                  ) +
                  "\n        "
              ),
              _c("br"),
              _vm._v(
                "— " +
                  _vm._s(
                    _setup.t("Сбор и визуализация аналитики", _setup.options)
                  ) +
                  "\n      "
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }